import { useEffect } from "react";
import {
  useBookingState,
  useBookingDispatch,
} from "../../../../hooks/useBookingState";
import { useProductDetail } from "../../../../hooks/useProductDetail";
import { SelectProductModalProps } from "./SelectProductModal";

export const useSelectProductModal = ({
  id,
  slug,
  isOpen,
  closeModal,
  bookingId,
}: SelectProductModalProps & {
  bookingId?: string;
}) => {
  const bookingState = useBookingState({
    mode: "FORM",
  });

  const bookingDispatch = useBookingDispatch({ mode: "POPUP" });
  const { productData, isLoading, isError } = useProductDetail(slug, {
    bookingId,
  });
  useEffect(
    function () {
      bookingDispatch.init(
        productData,
        bookingState.childrenLs?.find((x) => x.product?.id === productData?.id),
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [productData],
  );
  return {
    product: productData,
    isLoading,
    isError,
    id,
    isOpen,
    closeModal,
    bookingDispatch,
  };
};
